export const moneyUtils = {
  methods: {
    euroToCents (moneyNumber) {
      moneyNumber.toString().replaceAll(',', '.')
      return Math.round(moneyNumber * 100)
    }
  }
}
